import fetch from 'cross-fetch';
import {
	SendCrossPlatformAction,
	RemoteSendCrossPlatformEmailRequest,
	SendCrossPlatformEmailResponse,
	SendCrossPlatformEmailError,
} from './send-cross-platform-email';
import { addLPSLocaleHeader, sameOriginRequestPolicy } from '../actions';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export class RemoteSendCrossPlatformEmailAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}
	action: SendCrossPlatformAction = async (
		registerRequest: RemoteSendCrossPlatformEmailRequest,
		locale: string
	): Promise<SendCrossPlatformEmailResponse> => {
		const base = this.baseUrl || '';
		try {
			const response: Response = await fetch(
				`${base}/api/login-hub/send-cross-platform-email`,
				{
					...sameOriginRequestPolicy,
					method: 'POST',
					headers: addLPSLocaleHeader(
						{ 'Content-Type': 'application/json' },
						locale
					),
					body: JSON.stringify(registerRequest),
					mode: 'cors',
				}
			);

			if (response.status === HTTP_STATUS_NO_CONTENT) {
				return {
					status: HTTP_STATUS_NO_CONTENT,
				};
			}

			if (response.status === HTTP_STATUS_BAD_REQUEST || response.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
				try {
					const jsonResponse = await response.json();
					const errorType = jsonResponse?.error as SendCrossPlatformEmailError | undefined;
					return {
						status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
						error: errorType,
					};
				} catch (jsonError) {
					return {
						status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
					};
				}
			}

			return {
				status: response.status as typeof HTTP_STATUS_BAD_REQUEST | typeof HTTP_STATUS_INTERNAL_SERVER_ERROR,
			};
		} catch (e: unknown) {
			throw new Error('unexpected');
		}
	};
}
